export const Path = {
  CONFIG: '/config',
  LOGIN: '/login',
  REPORTS: '/reports',
  REPORTS_COMPANY: '/reports/company',
  REPORTS_COMPARATIVE: '/reports/comparative',
  REPORTS_PERSONALIZED: '/reports/personalized',
  REPORTS_PERSONALIZED_BASKETS: '/reports/personalized/baskets',
  REPORTS_SECTORAL: '/reports/sector',
  REPORTS_STATISTICS: '/reports/statistics',
  REPORTS_THEMES: '/reports/themes',
}

export const GLOBAL_VARIABLES = 'Variáveis globais'
export const ENVIRONMENTAL = 'Environmental'
export const SOCIAL = 'Social'
export const GOVERNANCE = 'Governance'

export const ESG_SECTIONS = ['environmental', 'social', 'governance'] as const

export const colorPalette = [
  '#1D2C3F',
  '#6A6B37',
  '#FFAF03',
  '#EAE1DC',
  '#2B4786',
  '#FFCE00',
  '#7F7F2E',
  '#0F1D2D',
  '#60602F',
  '#E89F0F',
  '#E0D6CE',
]

export const getCommonPieChartOptions = (device?: Device) => ({
  colors: colorPalette,
  chart: {
    type: 'pie',
    style: { fontFamily: 'Work Sans' },
  },
  credits: { text: '' },
  navigation: {
    buttonOptions: { enabled: false },
  },
  plotOptions: {
    pie: {
      innerSize: '25%',
      showInLegend: true,
      borderWidth: 1,
      borderColor: null as any,
    },
    series: {
      point: { events: { legendItemClick: () => false } },
    },
  },
  legend: {
    ...(device === 'mobile'
      ? {
          align: 'center' as const,
          layout: 'horizontal' as const,
          verticalAlign: 'bottom' as const,
        }
      : {
          align: 'right' as const,
          layout: 'vertical' as const,
          verticalAlign: 'middle' as const,
        }),
    width: 250,
    itemWidth: 250,
    itemMarginBottom: 8,
    itemStyle: {
      textOverflow: 'initial',
      fontWeight: '500',
    },
    symbolRadius: 0,
    symbolHeight: 12,
    symbolWidth: 30,
    squareSymbol: false,
    enabled: true,
  },
})
